<div class="remit position-relative text-center">
  <img
    src="/assets/img/resources/remit/remit-banner.png"
    alt=""
    class="img-fluid"
  />
</div>

<div class="remit-container">
  <!-- Remit Hero Section -->
  <section class="remit-section">
    <div class="container">
      <div class="row align-items-center min-vh-100">
        <!-- <div class="text-center">
          <h1 class="remit-title mb-4">
            Sending money to your loved ones in the Philippines has become
            <span class="text-primary">simple and easy.</span>
          </h1>
          <h2 class="remit-subtitle">
            With
            <strong class="brand-highlight">LOGO Mobile App</strong> you can now
            send money in just a few seconds.
          </h2>
        </div> -->
        <div class="col-lg-6 col-md-12 mb-5 mb-lg-0">
          <div class="remit-content">
            <div class="content-wrapper">
              <!-- Money Remittance Conversion -->
              <div class="remit-conversion">
                <div class="conversion-card">
                  <div class="conversion-header">
                    <h3 class="conversion-title">
                      <i class="fas fa-conversion me-2"></i>
                      Quick Rate Conversion
                    </h3>
                    <span class="live-rate-badge">
                      <i class="fas fa-circle me-1"></i>
                      Live Rates
                    </span>
                  </div>

                  <div class="conversion-wrapper">
                    <!-- Send Amount -->
                    <form [formGroup]="formSendAmount" autocomplete="off">
                      <div class="amount-group">
                        <label class="amount-label">WHEN YOU SEND</label>
                        <div class="amount-input-group">
                          <div class="currency-selector">
                            <img
                              src="/assets/img/country/us.png"
                              alt="US Flag"
                              class="flag-icon"
                            />
                            <span class="currency-code">USD</span>
                            <i class="fas fa-chevron-down"></i>
                          </div>
                          <input
                            formControlName="inputSendAmount"
                            required
                            appDecimal
                            formControlName="inputSendAmount"
                            (keyup)="onChangeSendAmount($event)"
                            type="text"
                            maxlength="7"
                            class="amount-input"
                          />
                        </div>

                        <div
                          *ngIf="
                            formSendAmount.get('inputSendAmount')?.invalid &&
                            (formSendAmount.get('inputSendAmount')?.dirty ||
                              formSendAmount.get('inputSendAmount')?.touched ||
                              isSubmitted)
                          "
                          class="text-danger"
                        >
                          <div
                            *ngIf="
                              formSendAmount.get('inputSendAmount')?.errors
                                ?.required
                            "
                          >
                            Minimum amount is $25.00
                          </div>
                          <div
                            *ngIf="
                              formSendAmount.get('inputSendAmount')?.errors?.min
                            "
                          >
                            Minimum amount is $25.00
                          </div>
                          <div
                            *ngIf="
                              formSendAmount.get('inputSendAmount')?.errors?.max
                            "
                          >
                            Maximum amount is $5,000.00
                          </div>
                        </div>
                      </div>

                      <!-- Conversion Arrow -->
                      <div class="conversion-arrow">
                        <div class="arrow-circle">
                          <i class="fas fa-arrow-down"></i>
                        </div>
                        <div class="exchange-rate">
                          <small
                            >1 USD =
                            {{
                              this.formSendAmount.get("selectReceiveCurrency")
                                ?.value == "USD"
                                ? 1
                                : (rate | number : "1.2-2")
                            }}
                            {{
                              this.formSendAmount.get("selectReceiveCurrency")
                                ?.value
                            }}
                            PHP</small
                          >
                        </div>
                      </div>

                      <!-- Receive Amount -->
                      <div class="amount-group">
                        <label class="amount-label">THEY WILL RECEIVE</label>
                        <div class="amount-input-group">
                          <div class="currency-selector">
                            <img
                              src="/assets/img/country/philippines.png"
                              alt="Philippines Flag"
                              class="flag-icon"
                            />
                            <span class="currency-code">PHP</span>
                            <i class="fas fa-chevron-down"></i>
                          </div>
                          <input
                            type="text"
                            class="amount-input receive-amount"
                            formControlName="inputReceiveAmount"
                            readonly
                          />
                        </div>
                      </div>

                      <!-- Fee Information -->
                      <!-- <div class="fee-info">
                        <div class="fee-breakdown">
                          <div class="fee-item">
                            <span>Transfer Fee:</span>
                            <span class="fee-value">{{
                              transferFee
                                | currency : "USD" : "symbol" : "1.2-2"
                            }}</span>
                          </div>
                          <div class="fee-item">
                            <span>Total Amount:</span>
                            <span class="fee-total">{{
                              totalAmount
                                | currency : "USD" : "symbol" : "1.2-2"
                            }}</span>
                          </div>
                        </div>
                      </div> -->
                    </form>

                    <!-- Action Button -->
                    <a
                      href="https://logoremit.com/auth/login"
                      class="btn btn-lg w-100 send-money-btn text-white"
                    >
                      <i class="fas fa-paper-plane me-2"></i>
                      Send Money Now
                    </a>
                  </div>
                </div>

                <!-- Trust Indicators -->
                <div class="trust-indicators mt-4">
                  <div class="row text-center">
                    <div class="col-4">
                      <div class="trust-item">
                        <i class="fas fa-shield-alt"></i>
                        <small>Bank-Level Security</small>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="trust-item">
                        <i class="fas fa-clock"></i>
                        <small>Minutes to Transfer</small>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="trust-item">
                        <i class="fas fa-users"></i>
                        <small>1M+ Users Trust Us</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12 text-center">
          <div class="conversion-image-wrapper">
            <div>
              <img
                src="/assets/img/resources/remit/covertion-remit-image.png"
                alt="LOGO Mobile App Interface"
                class="main-phone-image"
              />
              <div class="phone-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Steps Section -->
  <section class="steps-section py-5 bg-light">
    <div class="container">
      <div class="row">
        <div class="text-center mb-4">
          <h1 class="fw-bold display-5 text-success section-title">
            HOW IT WORKS
          </h1>
          <p class="text-muted fs-5">Follow these simple steps to send money</p>
        </div>
      </div>

      <div class="row g-4">
        <div
          class="col-lg-3 col-md-6"
          *ngFor="let step of steps; let i = index"
        >
          <div class="step-card h-100">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body text-center p-4">
                <div class="step-number mb-3">
                  {{ step.number }}
                </div>
                <div class="step-icon mb-3">
                  <i [class]="step.icon"></i>
                </div>
                <h5 class="card-title fw-bold mb-3">{{ step.title }}</h5>
                <p class="card-text text-muted">{{ step.description }}</p>
              </div>
            </div>
            <!-- <div class="step-connector" *ngIf="i < steps.length - 1">
              <i class="fas fa-arrow-right"></i>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Visual Steps Section -->
  <section class="visual-steps-section py-5">
    <div class="container">
      <div class="row align-items-center mb-5">
        <div class="col-md-6 mb-4 mb-md-0">
          <img
            src="/assets/img/resources/remit/step-1.jpg"
            alt="Login Screen"
            class="img-fluid rounded shadow"
          />
        </div>
        <div class="col-md-6">
          <div class="ps-md-4">
            <span class="badge bg-primary fs-6 mb-3">STEP 1</span>
            <h3 class="fw-bold mb-3">Quick Account Access</h3>
            <p class="text-muted mb-4">
              Secure login with biometric authentication or traditional
              credentials. New users can register in minutes with our
              streamlined onboarding process.
            </p>
            <ul class="list-unstyled">
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>Fingerprint
              </li>
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>Device
                Registration
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row align-items-center mb-5">
        <div class="col-md-6 order-md-2 mb-4 mb-md-0">
          <img
            src="/assets/img/resources/remit/step-2.jpg"
            alt="Send Money Interface"
            class="img-fluid rounded shadow"
          />
        </div>
        <div class="col-md-6 order-md-1">
          <div class="pe-md-4">
            <span class="badge bg-primary fs-6 mb-3">STEP 2</span>
            <h3 class="fw-bold mb-3">Enter Send Amount</h3>
            <p class="text-muted mb-4">
              Simple and intuitive interface to enter the amount you want to
              send. Real-time exchange rates and transparent fee structure.
            </p>
            <ul class="list-unstyled">
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>Live Exchange
                Rates
              </li>
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>No Hidden Fees
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row align-items-center mb-5">
        <div class="col-md-6 mb-4 mb-md-0">
          <img
            src="/assets/img/resources/remit/step-3.jpg"
            alt="Recipient Selection"
            class="img-fluid rounded shadow"
          />
        </div>
        <div class="col-md-6">
          <div class="ps-md-4">
            <span class="badge bg-primary fs-6 mb-3">STEP 3</span>
            <h3 class="fw-bold mb-3">Recipient Information</h3>
            <p class="text-muted mb-4">
              Add new recipients or select from your saved beneficiaries. Choose
              from various payout methods for recipient convenience.
            </p>
            <ul class="list-unstyled">
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>Bank Transfer
              </li>
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>Cash Pickup
              </li>
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>Mobile Wallet
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-md-6 order-md-2 mb-4 mb-md-0">
          <img
            src="/assets/img/resources/remit/step-4.jpg"
            alt="Transaction Confirmation"
            class="img-fluid rounded shadow"
          />
        </div>
        <div class="col-md-6 order-md-1">
          <div class="pe-md-4">
            <span class="badge bg-primary fs-6 mb-3">STEP 4</span>
            <h3 class="fw-bold mb-3">Confirm & Send</h3>
            <p class="text-muted mb-4">
              Review all transaction details and confirm your money transfer.
              Get instant confirmation and tracking number for your peace of
              mind.
            </p>
            <ul class="list-unstyled">
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>Instant
                Confirmation
              </li>
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>Transaction
                Tracking
              </li>
              <li class="mb-2">
                <i class="fas fa-check text-success me-2"></i>SMS Notifications
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="cta-section py-5">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-lg-8">
          <div class="text-center mb-4">
            <h1 class="fw-bold display-5 text-success section-title">
              START SENDING MONEY TODAY
            </h1>
            <p class="text-muted fs-5">
              Join thousands of users who trust LOGO Mobile App for their money
              transfer needs.
            </p>
          </div>
          <div
            class="download d-flex flex-column flex-sm-row justify-content-center gap-3"
          >
            <a
              href="https://apps.apple.com/ph/app/logo-mobile/id1585548899"
              target="_blank"
            >
              <img
                src="/assets/img/badge/download-app-store.png"
                alt=""
                class="download-app-store"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.axp.customer&hl=en"
              target="_blank"
            >
              <img
                src="/assets/img/badge/download-google-play.png"
                alt=""
                class="download-google-play"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
